import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Medal = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 4.00002H5C4.45 4.00002 4 4.45002 4 5.00002V9.00002C4 11.762 6.237 14 9 14H15V16.087C12.162 16.562 10 19.037 10 22C10 25.313 12.688 28 16 28C19.312 28 22 25.312 22 22C22 19.038 19.837 16.562 17 16.087V13.999H23C25.762 13.999 28 11.762 28 8.99902V4.99902C28 4.44902 27.55 3.99902 27 3.99902V4.00002ZM6 9.00002V6.00002H10V12H9C7.35 12 6 10.65 6 9.00002ZM20 22C20 24.2 18.2 26 16 26C13.8 26 12 24.2 12 22C12 19.8 13.8 18 16 18C18.2 18 20 19.8 20 22ZM12 12V6.00002H20V12H12ZM26 9.00002C26 10.65 24.65 12 23 12H22V6.00002H26V9.00002Z" />
	</svg>
);

export default Medal;
